<template>
    <div class="page flex-col">
        <div class="wrap1 flex-col">
            <!-- <img
                class="label3"
                referrerpolicy="no-referrer"
                src="https://lanhu.oss-cn-beijing.aliyuncs.com/SketchPngc2873af9ca5fe49933bdf83bacfabf622ff0a0cfdc58e0c0c3e17e226463820b"
            /> -->
            <img src="../assets/signIn/Completed.png" class="label3">
            <span class="word2">用户已完成到店核销</span>
            <!-- <span class="word3">操作用户到店成功</span> -->
            <span class="word3">该用户已于 {{ time }} 完成过核销</span>
            <div class="back-btn" @click="goBack">返回</div>
        </div>
    </div>
</template>
<script>
export default {
    data(){
        return{
            time:''
        }
    },
    created(){
        this.time = this.$route.query.arriveCheckTime;
    },
    methods: {
        goBack() {
            this.$router.go(-1);
        }
    }
}
</script>

<style lang="less" scoped>
.page {
    z-index: 1;
    position: relative;
    width: 375px;
    height:100vh;
    background-color: rgba(255, 255, 255, 1);
    overflow: hidden;
    justify-content: flex-start;
    padding-top: 0;
}

.wrap1 {
    z-index: auto;
    width: 375px;
    height: 323px;
}
.box3 {
    z-index: 2;
    height: 44px;
    background-color: rgba(255, 255, 255, 1);
    width: 375px;
    justify-content: center;
    align-items: flex-start;
    padding-left: 25px;
}

.layer4 {
    z-index: auto;
    width: 197px;
    height: 24px;
    justify-content: space-between;
}

.txt1 {
    z-index: 21;
    width: 68px;
    display: block;
    overflow-wrap: break-word;
    color: rgba(36, 40, 51, 1);
    font-size: 17px;
    font-family: PingFangSC-Medium;
    white-space: nowrap;
    line-height: 24px;
    text-align: center;
    margin-left: 33vw;
}

.label3 {
    width: 84px;
    height: 84px;
    align-self: center;
    margin-top: 119px;
}

.word2 {
    color: rgba(36, 40, 51, 1);
    font-size: 18px;
    text-align: center;
    margin-top: 20px;
    font-weight: bold;
}

.word3 {
    color: rgba(109, 114, 120, 1);
    font-size: 14px;
    text-align: left;
    align-self: center;
    margin-top: 15px;
}
// 公共样式
body * {
    box-sizing: border-box;
    flex-shrink: 0;
}
body {
    font-family: PingFangSC-Regular, Roboto, Helvetica Neue, Helvetica, Tahoma,
        Arial, PingFang SC-Light, Microsoft YaHei;
}
button {
    margin: 0;
    padding: 0;
    border: 1px solid transparent;
    outline: none;
    background-color: transparent;
}

button:active {
    opacity: 0.6;
}
.flex-col {
    display: flex;
    flex-direction: column;
}
.flex-row {
    display: flex;
    flex-direction: row;
}
.back-btn {
    width: 80%;
    margin: 0 auto;
    padding: 10px 8px;
    background-color: #17c1ce;
    border-radius: 4px;
    color: #ffffff;
    text-align: center;
    font-size: 16px;
    margin-top: 80%;
}
</style>
